<div class="title-wrapper mb-16">
  <h3 class="title s-16 mb-16">Behavior Rating</h3>
  <p class="text s-16">
    Score: {{ enteredData?.reviewScoreType?.reviewScore }}.
    {{ enteredData?.reviewScoreType?.reviewText }}
  </p>
</div>
<app-correction-needed-form
  [fidelityData]="fidelityData"
  [fidelityFormData]="enteredData"
  (formValueChange)="formValueChange.emit($event)"></app-correction-needed-form>
